module.exports = __webpack_public_path__ + "static/img/not-found.1c15ba39.png";